import * as types from '../../action-types';
import { uploadBankStatement as initialState } from "../../initialState";

const uploadBankStatement = (state=initialState, action) => {
  switch (action.type) {
    case types.UPLOAD_BANK_STATEMENT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.UPLOAD_BANK_STATEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.UPLOAD_BANK_STATEMENT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPLOAD_BANK_STATEMENT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default uploadBankStatement;
